import { styled } from '@mui/material';

export const StyledTable = styled('table')({
	width: '100%',
	borderCollapse: 'collapse',
});

export const StyledTr = styled('tr')({
	'&:nth-of-type(even)': {
		backgroundColor: '#F8F8F8',
	},
});

export const StyledTrInverted = styled('tr')({
	'&:nth-of-type(odd)': {
		backgroundColor: '#F8F8F8',
	},
});

export const StyledTh = styled('th')(({ theme }) => ({
	padding: theme.spacing(1),
	fontSize: '17px',
	backgroundColor: '#F1F1F1',
	textAlign: 'center',
	position: 'sticky',
	top: 0,
	zIndex: 1,
}));

export const StyledThUnstyled = styled('th')(({ theme }) => ({
	padding: theme.spacing(1),
	fontSize: '17px',
	backgroundColor: 'white',
	textAlign: 'center',
	position: 'sticky',
	top: 0,
	zIndex: 1,
}));

export const StyledTd = styled('td')(({ theme }) => ({
	padding: theme.spacing(1),
	textAlign: 'center',
	fontSize: '15px',
}));
